import React from 'react';

interface ArrowLeftProps {
  style?: React.CSSProperties;
  className?: string;
}

const ArrowLeft = ({ style, className }: ArrowLeftProps) => (
  <svg
    className={className}
    style={style}
    width="8"
    height="10"
    viewBox="0 0 8 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path id="arrow left" d="M2.18557e-07 5L7.5 9.33013L7.5 0.669872L2.18557e-07 5Z" fill="#616161" />
  </svg>
);
export default ArrowLeft;
